<template>
  <div class="modal-mask" v-if="visible">
    <div class="modal-wrapper" @click.self="close">
      <div class="modal-container">
        <div class="modal-header">
          <h5>GPS térkép</h5>
          <button @click="close">×</button>
        </div>
        <div class="modal-body" ref="map" style="height: 400px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet';

export default {
  props: {
    gps: String,
    visible: Boolean
  },
  data() {
    return {
      map: null
    };
  },


watch: {
  visible(newVal) {
    if (newVal) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.initMap();
          this.map?.invalidateSize(); // ZWINGT Leaflet zur Neuberechnung
        }, 200);
      });
    }
  }
},



  methods: {
close() {
  if (this.map) {
    this.map.remove();
    this.map = null;
  }
  this.$emit('close');
},


 initMap() {
  console.log('initMap called with gps:', this.gps);
  if (!this.gps || !this.$refs.map) return;

  const [lat, lng] = this.gps.split(',').map(p => parseFloat(p.trim()));

  if (this.map) {
    this.map.setView([lat, lng], 15);
    return;
  }

  this.map = L.map(this.$refs.map).setView([lat, lng], 15);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© OpenStreetMap contributors'
  }).addTo(this.map);

L.marker([lat, lng], {
  icon: L.divIcon({
    className: 'custom-gps-marker',
    html: `<i class="fas fa-map-marker-alt"></i>`,  // Stelle sicher, dass Font Awesome eingebunden ist!
    iconSize: [30, 30],
    iconAnchor: [15, 30]
  })
}).addTo(this.map);


}




  }
};
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.modal-container {
  background: white;
  border-radius: 8px;
  width: 600px;
  max-width: 90%;
  padding: 1rem;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  height: 400px;
  padding: 0;
}


.custom-gps-marker i {
  color: red;
  font-size: 60px;
  text-shadow: 0 0 3px white;
}

</style>
